import mapSliceToComponent from '~/imports/category_page'

import { SliceManager } from '@unlikelystudio/react-abstract-components'

import { PageViewAnalytics } from '~/components/PageViewAnalytics'
import PageWithFiltersWrapper from '~/components/PageWithFilters'
import HeroCategory from '~/components/UI/HeroCategory'

import getCategoryPageStaticPropsFunction, {
  CategoryPageData,
} from '~/data/category-page-data'

export default function CategoryPage({
  slices,
  heroData,
  ...props
}: CategoryPageData) {
  const { image, mobileImage } = heroData ?? {}

  const hasHeroImage = Boolean(image || mobileImage)

  return (
    <>
      <HeroCategory {...heroData} />
      <PageWithFiltersWrapper {...props} withPriority={!hasHeroImage}>
        <SliceManager
          mapSliceTypeToComponent={mapSliceToComponent}
          slicesData={slices}
        />
      </PageWithFiltersWrapper>
      <PageViewAnalytics template="collection" />
    </>
  )
}

export const getStaticProps = getCategoryPageStaticPropsFunction()
